import React from 'react';
import superagent from 'superagent';
import {Modal, Button} from 'react-bootstrap';

import { LoggedUserAdmin, LoggedUserId } from '../login/Login';

import InfoMsg  from '../../api/InfoMsg';
import UsersEditModal from './UsersEditModal';

import styles from '../kalendar/Home.css';

export default class Users extends React.Component {

  constructor() {
    super();
    this.state = {
      errorMessage: '',
      errorMessageReg: '',
      styleMsg: '',
      userList: null,
      userID: null,
      show: false,
      editModal: null,
    };

    this.handleChange = this.handleChange.bind(this);
    this.changeUser = this.changeUser.bind(this);
    this.setUserList = this.setUserList.bind(this);
  }

  showEditModal() {
    $('#exampleModalCenter').modal('show');
  }

  changeUser(e) {
    e.preventDefault();
    this.setState({ editModal: {userID: e.target.dataset.userid, jmeno: e.target.dataset.jmeno, email: e.target.dataset.email, lekce: e.target.dataset.lekce, aktivni: e.target.dataset.aktivni}}, this.showEditModal);
  }

  componentWillMount = () => {
    var ubytovaniObj = superagent.get('https://rezervace.copasedeje.cz/servis/_user_list.php?userID=' + LoggedUserId() + '&t=' + Date()).set('Content-Type', 'application/json').then(response => {
      var myObject = JSON.parse(response.text);
      this.setState({userList: myObject});
    });
  }

  setUserList(myObject) {
    this.setState({userList: myObject});
  }

  handleChange() {
    this.setState({errorMessage: '', styleMsg: ''});
  }

  render() {
    if (!LoggedUserAdmin) {
      return null;
    }
    if (this.state.userList == null) {
      return null;
    }

    var items = this.state.userList.map(function(item, index) {
      return (
        <tr key={item.id_user}>
          <td className="text-left cursor-pointer" data-jmeno={item.jmeno} data-email={item.email} data-userid={item.id_user} data-lekce={item.lekce} data-aktivni={item.aktivni} onClick={this.changeUser}>{item.jmeno}</td>
          <td className="text-left d-none d-sm-table-cell cursor-pointer" data-jmeno={item.jmeno} data-email={item.email} data-userid={item.id_user} data-lekce={item.lekce} data-aktivni={item.aktivni} onClick={this.changeUser}>{item.email}</td>
          <td className="text-center cursor-pointer" data-jmeno={item.jmeno} data-email={item.email} data-userid={item.id_user} data-lekce={item.lekce} data-aktivni={item.aktivni} onClick={this.changeUser}>{item.lekce}</td>
          <td className="text-center cursor-pointer" data-jmeno={item.jmeno} data-email={item.email} data-userid={item.id_user} data-lekce={item.lekce} data-aktivni={item.aktivni} onClick={this.changeUser}>{item.aktivni}</td>
        </tr>
      )
    }.bind(this));

    return (
      <div className={styles.root}>
        <h1 className={styles.panelHeader}>Seznam uživatelů</h1>
        <div className={"table-responsive shadow " + styles.tablePanel}>
          <InfoMsg styleBS={this.state.styleMsg} text={this.state.errorMessage}/>
          <table className={"table table-striped table-hover "}>
            <thead>
              <tr>
                <th>Jméno</th>
                <th className="d-none d-sm-table-cell">Email</th>
                <th className="text-center">Lekce</th>
                <th className="text-center">Aktivní</th>
              </tr>
            </thead>
            <tbody>
              {items}
            </tbody>
          </table>
        </div>

        <UsersEditModal editModal={this.state.editModal} setUserList={this.setUserList} />

      </div>
    );
  }


}



// WEBPACK FOOTER //
// src/components/users/Users.js